<template>
  <div class="header">
    <b-navbar toggleable="sm" type="dark" variant="default">
      <b-navbar-brand href="#">{{productName}}</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <div v-for="menu in menus" :key="menu.name">
            <!--二级菜单循环-->
            <b-nav-item-dropdown v-if="menu.menus" tag="li" :to="menu.path">
              <template v-slot:button-content>
                <!-- <router-link :to="menu.path"> -->
                <span>{{menu.name}}</span>
                <!-- </router-link> -->
              </template>

              <b-dropdown-item
                :to="submenu.path"
                :key="submenu.name"
                v-for="submenu in menu.menus"
              >{{submenu.name}}</b-dropdown-item>
            </b-nav-item-dropdown>
            <!--一级级菜单-->
            <b-nav-item :to="menu.path" v-else>{{menu.name}}</b-nav-item>
          </div>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
           <b-nav-item-dropdown>
            <template v-slot:button-content>
              <span>{{info.fullName ? `欢迎您,${info.fullName}` : '未登录'}}</span>
            </template>
            <b-dropdown-item to="/pwdchange">更改密码</b-dropdown-item>
            <b-dropdown-item @click.native="logOff">注销</b-dropdown-item>
          </b-nav-item-dropdown> 
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- <b-toast
      :id="alert.instrumentCode"
      variant="danger"
      solid
      :no-auto-hide="true"
      :append-toast="true"
      :key="alert.insturmentCode"
      v-for="alert in alerts"
    >
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <strong class="mr-auto">数据采集预警</strong>
          <small class="text-muted mr-2">{{alert.alertDate}}</small>
        </div>
      </template>
      <template #default>
        <div class="align-items-baseline">
          <div style="min-height:35px;">{{alert.alertMessage}}</div>
          <div>
            <b-button
              variant="danger"
              class="mr-2 pull-right"
              size="sm"
              @click="handleAction(alert.id)"
            >处置</b-button>
          </div>
        </div>
        <div></div>
      </template>
    </b-toast>-->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import setting from "@/setting.js";

export default {
  name: "Header",
  data() {
    return {
      router: this.$route,
      productName:'票管家',
      menus: []
    };
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },

  methods: {
    ...mapActions("admin/account", ["logout"]),

/**
     * @description 登出
     */
    logOff() {
      this.logout();
    },
    initInfo() {
      let roles = this.info.roles;
      let role = "";
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        role = "sys_admin";
      } else if (roles.indexOf("org_admin") > -1) {
        role = "org_admin";
      } else {
        role = "org_fin";
      }
      let appId = this.info.orgId==process.env.VUE_APP_MAERSK_ORG_ID ? "maersk" : "standard";

      if(roles[0].indexOf("tcs_")>-1){
        appId="tcs";
        this.productName="信链";
      }
    
     // let roleMenu = setting.roles.find(e => e.role == role && e.appId == appId);

     let roleMenu = setting.roles.find(e => roles.indexOf(e.role)>-1 && e.appId == appId);

      this.menus = roleMenu.menus;
      console.log(this.info.orgId)
    }
  },
  created() {
    this.initInfo();
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
/* .navbarBg {
  min-height: 4rem;
  background: #563d7c;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.svgSize {
  width: 1rem;
  height: 1rem;
  vertical-align: text-top;
}
.navbarBg .navbar-nav .nav-link {
  color: #cbbde2;
}
.nav-item a,.nav-item a span{
  color:#fff !important;
}
.header .navbar-nav .nav-link {
   color:#fff !important;
}
.nav-link,.dropdown-toggle>span{
  color:#fff !important;
}

*/
.navbar,
.navbar-nav {
  height: 50px;
  /* padding-top: 16px;
  padding-bottom: 18px; */
}

li.nav-item {
  line-height: 50px;
}
.dropdown-menu {
  /* font-size: 14px; */
  margin: -1px 0;
}
.dropdown-menu a {
  line-height: 1.5rem;
}
.nav-item > a {
  /* padding-left: 1rem !important;
  padding-right: 1rem !important; */
  padding: 0px 1rem !important;
}

.navbar-dark .navbar-nav .nav-link {
  color: #fff !important;
}
.nav-link {
  color: #fff !important;
}
.bg-default {
  background-color: #0098ce !important;
}
/* .nav-link:focus, */
.nav-link:hover,
.show .nav-link {
  background-color: #0080ad !important;
}
/* .navbar-nav > .show > a,
.navbar-nav > .show > a:hover,
.navbar-nav > .show > a:focus {
  background-color: #0080ad !important;
  color: #fff;
} */

a:hover {
  text-decoration: none;
}
.toast-body {
  height: 80px;
}
</style>
